<section class="video-area ptb-100 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="video-content">
            <span class="sub-title">Watch Video</span>
            <h2>Get Ready To Start Your Exciting Journey</h2>
            <a href="https://www.youtube.com/watch?v=bk7McNUjWgw" class="video-btn popup-youtube"><i class='bx bx-play'></i></a>
        </div>
    </div>
</section>